import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLoggedIn: false,
        token: '',
        user: {}
    },
    reducers: {
        loginSuccess: (state, action) => {
            state.isLoggedIn = true
            state.token = action.payload.token
            state.user = action.payload.user
            localStorage.setItem('token', action.payload.token)
            localStorage.setItem('user', JSON.stringify(action.payload.user))
        },
        logout: (state) => {
            state.isLoggedIn = false
            state.token = ''
            state.user = ''
            localStorage.clear()
        }, 
        updateUser: (state, action) => {
            state.user = action.payload
            localStorage.setItem('user', JSON.stringify(action.payload))
        }
    }
})


export const { loginSuccess, logout, updateUser } = authSlice.actions
export default authSlice.reducer